import { type AggregationFn } from "@tanstack/react-table";

import { round } from "./aggregationFnUtils";

/**
 * NOTE: This function is called `empty` because we want it to show up as `empty` in the DataGrid
 * UI, and that is determined by the `name` field of the function.
 */
export const empty: AggregationFn<unknown> = (columnId, leafRows) => {
	let emptyCount = 0;
	let totalCount = 0;
	leafRows.forEach((row) => {
		const value = row.getValue(columnId);
		totalCount += 1;
		if (value === null || value === "" || value === undefined) {
			emptyCount += 1;
		}
	});

	if (totalCount === 0 || emptyCount === 0) {
		return "0%";
	}
	return `${round((emptyCount / totalCount) * 100)}%`;
};
